import { useEffect, useRef, useState } from 'react';
import { WorkspacesListingItem } from '@futrli-sdk/workspaces';
import { fetchWorkspacesData } from '../../workspaces/api';

export const useLoadWorkspacesData = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<WorkspacesListingItem[]>();

  const isFirstRun = useRef(true);

  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      setData(await fetchWorkspacesData());
      setIsLoading(false);
    };

    if (isFirstRun.current) {
      loadData();
      isFirstRun.current = false;
    }
  }, []);

  return {
    isLoading,
    data
  };
};
